<template>
  <div>
    <div
      v-for="(item, index) in value"
      :key="index"
    >
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {}
  },
  methods: {},
  components: {}
}
</script>

<style></style>
